import React, { FC } from 'react';
import ArrowRight from '../icons/ArrowRight';
import * as styles from './MoreCard.module.scss';
import { LocalLink } from '../html-tag/localLink';

interface IProps {
  title: string;
  link: string;
  overlayColor?: string | undefined | null;
  linkLabel: string;
  textColor: string | undefined | null;
  arrowColor: string | undefined | null;
  imgUrl?: string | undefined | null;
}

const MoreCard: FC<IProps> = ({
  arrowColor,
  linkLabel,
  textColor,
  title,
  imgUrl,
  overlayColor,
  link,
}) => {
  return (
    <article className={styles.wrapper}>
      <h2 style={{ color: textColor as string }}>{title}</h2>
      <div
        className={styles.linkWrapper}
        style={{ color: textColor as string }}
      >
        <LocalLink to={link}>{linkLabel}</LocalLink>
        <ArrowRight color={(arrowColor as string) || 'white'} />
      </div>
      <div
        className={styles.overlay}
        style={{ background: overlayColor as string, opacity: imgUrl ? 0.5 : 1 }}
      />
      {imgUrl && (
        <img
          src={imgUrl}
          alt=""
        />
      )}
    </article>
  );
};
export default MoreCard;
